import { isDuotoneFamily } from 'app/releases'

export const IconsMixins = {
  data() {
    return {}
  },

  computed: {
    isDuotoneIcon() {
      // If this is an iconUpload, the selectedStyle will not be 'duotone',
      // but if it has duotone pathData, it should still be treated as a duotone icon.
      // family: classic style: duotone check covers version 5
      return isDuotoneFamily(this.styling?.family) || !!this.icon?.pathSecondary || (this.styling?.family === 'classic' && this.styling?.style === 'duotone')
    }
  },

  methods: {
    normalizeBrandsIcon(icon) {
      // Convert brands icons to display format (family: 'brands', style: 'solid')
      // This matches the pattern used in IconLanding and other components
      // See: IconLanding.vue line 495-498 for the same conversion logic
      if (icon.family === 'brands' || icon.style === 'brands') {
        return { ...icon, family: 'brands', style: 'solid' }
      }
      return icon
    },

    normalizeBrandsFamilyStyle(familyStyle) {
      // Use the same normalization logic as normalizeBrandsIcon but for familyStyle objects
      if (familyStyle.family === 'brands' || familyStyle.style === 'brands') {
        return { ...familyStyle, family: 'brands', style: 'solid' }
      }
      return familyStyle
    }
  }
}
